const List = () => import("@/pages/master/scheduled-report/List")
const Form = () => import("@/pages/master/scheduled-report/Form")
// import List from '@/pages/master/scheduled-report/List'
// import Form from '@/pages/master/scheduled-report/Form'
import layout from "@/layout/Master"

const data = [
  {
    path: "/master/scheduled-report",
    name: "scheduled-report-list",
    components: {
      content: List,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Scheduled Report" },
        { title: "List", active: true }
      ],
      title: "Scheduled Report List",
      module: "Scheduled Report",
      showLink: false,
      requiresAuth: true
    }
  },
  {
    path: "/master/scheduled-report/create",
    name: "scheduled-report-create",
    components: {
      content: Form,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Scheduled Report" },
        { title: "Create", active: true }
      ],
      title: "Scheduled Report Create",
      module: "Scheduled Report",
      showLink: false,
      requiresAuth: true
    }
  },
  {
    path: "/master/scheduled-report/view/:id",
    name: "scheduled-report-view",
    components: {
      content: Form,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Scheduled Report" },
        { title: "View", active: true }
      ],
      title: "Scheduled Report View",
      module: "Scheduled Report",
      showLink: false,
      requiresAuth: true
    }
  },
  {
    path: "/master/scheduled-report/edit/:id",
    name: "scheduled-report-edit",
    components: {
      content: Form,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Scheduled Report" },
        { title: "Edit", active: true }
      ],
      title: "Scheduled Report Edit",
      module: "Scheduled Report",
      showLink: false,
      requiresAuth: true
    }
  }
]
export default data
